import { PageLayout } from '../components/PageLayout'

export function Cookies() {
  return (
    <PageLayout title="Política de Cookies" lastUpdated="17 de Janeiro de 2025">
      <section>
        <h2>1. O Que São Cookies</h2>
        <p>
          Cookies são pequenos arquivos de texto armazenados no seu dispositivo (computador,
          tablet ou celular) quando você visita um site. Eles são amplamente utilizados para
          fazer os sites funcionarem de forma mais eficiente, bem como para fornecer informações
          aos proprietários do site.
        </p>
      </section>

      <section>
        <h2>2. Como Usamos Cookies</h2>
        <p>
          O SecBrain Neurodivergente utiliza cookies e tecnologias similares para diversos fins:
        </p>

        <h3>2.1. Cookies Essenciais</h3>
        <p>
          Necessários para o funcionamento básico da plataforma. Sem eles, alguns serviços
          não funcionariam corretamente.
        </p>
        <table>
          <thead>
            <tr>
              <th>Cookie</th>
              <th>Finalidade</th>
              <th>Duração</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>session_id</td>
              <td>Manter sua sessão ativa</td>
              <td>Sessão</td>
            </tr>
            <tr>
              <td>auth_token</td>
              <td>Autenticação segura</td>
              <td>7 dias</td>
            </tr>
            <tr>
              <td>csrf_token</td>
              <td>Proteção contra ataques CSRF</td>
              <td>Sessão</td>
            </tr>
          </tbody>
        </table>

        <h3>2.2. Cookies de Preferências</h3>
        <p>
          Permitem que a plataforma lembre de suas escolhas e preferências, proporcionando
          uma experiência mais personalizada.
        </p>
        <table>
          <thead>
            <tr>
              <th>Cookie</th>
              <th>Finalidade</th>
              <th>Duração</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>theme</td>
              <td>Preferência de tema (claro/escuro)</td>
              <td>1 ano</td>
            </tr>
            <tr>
              <td>sidebar_state</td>
              <td>Estado da barra lateral</td>
              <td>1 ano</td>
            </tr>
            <tr>
              <td>locale</td>
              <td>Idioma preferido</td>
              <td>1 ano</td>
            </tr>
          </tbody>
        </table>

        <h3>2.3. Cookies de Análise</h3>
        <p>
          Nos ajudam a entender como os visitantes interagem com nossa plataforma,
          permitindo melhorias contínuas.
        </p>
        <table>
          <thead>
            <tr>
              <th>Cookie</th>
              <th>Finalidade</th>
              <th>Duração</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>_ga</td>
              <td>Google Analytics - identificação</td>
              <td>2 anos</td>
            </tr>
            <tr>
              <td>_gid</td>
              <td>Google Analytics - sessão</td>
              <td>24 horas</td>
            </tr>
          </tbody>
        </table>
      </section>

      <section>
        <h2>3. Cookies de Terceiros</h2>
        <p>
          Alguns cookies são definidos por serviços de terceiros que aparecem em nossas páginas:
        </p>
        <ul>
          <li><strong>Google Analytics:</strong> análise de uso e comportamento</li>
          <li><strong>Intercom/Chat:</strong> suporte ao cliente (quando disponível)</li>
          <li><strong>Stripe:</strong> processamento de pagamentos</li>
        </ul>
        <p>
          Cada um desses serviços tem sua própria política de privacidade e cookies.
        </p>
      </section>

      <section>
        <h2>4. Gerenciando Cookies</h2>
        <p>
          Você pode controlar e gerenciar cookies de várias formas:
        </p>

        <h3>4.1. Configurações do Navegador</h3>
        <p>
          A maioria dos navegadores permite que você recuse cookies ou exclua cookies
          existentes. As instruções variam conforme o navegador:
        </p>
        <ul>
          <li><strong>Chrome:</strong> Configurações {'>'} Privacidade e segurança {'>'} Cookies</li>
          <li><strong>Firefox:</strong> Opções {'>'} Privacidade & Segurança {'>'} Cookies</li>
          <li><strong>Safari:</strong> Preferências {'>'} Privacidade {'>'} Cookies</li>
          <li><strong>Edge:</strong> Configurações {'>'} Cookies e permissões de site</li>
        </ul>

        <h3>4.2. Opt-out de Analytics</h3>
        <p>
          Para desativar o Google Analytics, você pode instalar o{' '}
          <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener noreferrer">
            complemento de desativação
          </a>.
        </p>

        <h3>4.3. Impacto da Desativação</h3>
        <p>
          Note que desativar cookies essenciais pode afetar o funcionamento da plataforma,
          incluindo a impossibilidade de manter sua sessão ativa.
        </p>
      </section>

      <section>
        <h2>5. Outras Tecnologias de Rastreamento</h2>
        <p>
          Além de cookies, podemos utilizar tecnologias similares:
        </p>
        <ul>
          <li>
            <strong>Local Storage:</strong> armazena dados localmente no navegador sem
            data de expiração
          </li>
          <li>
            <strong>Session Storage:</strong> similar ao local storage, mas os dados são
            apagados ao fechar a aba
          </li>
          <li>
            <strong>Pixels:</strong> imagens pequenas que podem confirmar visualizações
            de e-mails ou páginas
          </li>
        </ul>
      </section>

      <section>
        <h2>6. Base Legal</h2>
        <p>
          O uso de cookies é baseado em:
        </p>
        <ul>
          <li>
            <strong>Cookies essenciais:</strong> legítimo interesse para funcionamento
            do serviço contratado
          </li>
          <li>
            <strong>Cookies de preferências e analytics:</strong> consentimento do usuário
          </li>
        </ul>
      </section>

      <section>
        <h2>7. Atualizações desta Política</h2>
        <p>
          Esta Política de Cookies pode ser atualizada periodicamente para refletir
          mudanças em nossas práticas ou nos serviços utilizados. A data da última
          atualização está indicada no topo desta página.
        </p>
      </section>

      <section>
        <h2>8. Contato</h2>
        <p>
          Para dúvidas sobre nossa Política de Cookies:
        </p>
        <ul>
          <li>E-mail: <a href="mailto:info@secbra.in">info@secbra.in</a></li>
        </ul>
      </section>
    </PageLayout>
  )
}
